import { Form } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useStore } from 'store/useStore'
import { EmployeeKeys } from 'sections/LKSection/modules/EmployeeModule/data'
import { getCreateOrderPageKey } from 'sections/LKSection/modules/OrderModule/utils'
import { CodeInput } from 'sections/LKSection/shared/components/CodeInput/CodeInput'
import { BgBox } from 'sections/LKSection/shared/components/UI/BgBox/BgBox'
import { Button, Flex, Text } from 'components/uiKit'

const getKey = (key: string) => `${EmployeeKeys.addEmployeePage}.${key}`

export const VerificationEmployeeStep = observer(() => {
  const { viewEmployeeUiStore: uiStore } = useStore()

  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    uiStore.setCode('')
  }, [])

  const handleSetCode = async (code: string) => {
    uiStore.setCode(code)

    if (code.length !== 4) {
      return
    }

    setLoading(true)
    const result = await uiStore.verifyEmployee()
    setLoading(false)

    if (result) {
      uiStore.setSelectedStep(uiStore.selectedStep + 1)
      uiStore.getEmployeeList()
    }
  }

  return (
    <BgBox py={32}>
      <Flex vertical gap={16}>
        <Text>{t(getKey('Отправили код данному сотруднику'))}</Text>

        <Form layout="vertical" requiredMark={false}>
          <Form.Item>
            <CodeInput value={uiStore.code} length={4} onChange={(value) => handleSetCode(value)} />
          </Form.Item>
        </Form>

        <Flex gap={16}>
          <Button onClick={() => uiStore.setSelectedStep(uiStore.selectedStep - 1)} type="default" loading={loading}>
            {t(getCreateOrderPageKey('Предыдущий шаг'))}
          </Button>
        </Flex>
      </Flex>
    </BgBox>
  )
})
